import CreditReportClient from '@/api/CampusAdmin/CreditReportsClient';
import moment from 'moment';

export default class CollegeDetailsReport {
  constructor() {
    this.creditReportClient = null;
    this.schoolId = 0;

    this.loading = true;
    this.error = null;
    this.parameters = {
      from: null,
      through: null,
      binBy: 'month',
      customCampusTags: [],
    };
    this.individual = {};
    this.workshop = {};
  }

  initialize($http, schoolId) {
    this.creditReportClient = new CreditReportClient($http);
    this.schoolId = schoolId;

    return this;
  }

  withCustomTags(tags) {
    this.parameters.customCampusTags = tags
    return this;
  }

  between(from, through) {
    this.parameters.from = from ? moment(from).toISOString() : null;
    this.parameters.through = through ? moment(through).toISOString() : null;

    return this;
  }
  byBin(bin) {
    this.parameters.binBy = bin;
    
    return this;
  }

  async fetch() {

    try {
      this.loading = true;

      const response = await this.creditReportClient.getBinnedUsageReport(
        this.schoolId,
        this.parameters.from,
        this.parameters.through,
        this.parameters.binBy,
        this.parameters.customCampusTags
      );

      this.individual = response.individual;
      this.workshop = response.workshop;

    } finally {
      this.loading = false;
    }
  }
}
